(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nordelia-sticky-atc"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nordelia-sticky-purchase')) {
    customElements.define('nordelia-sticky-purchase', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.sid = this.dataset.section;
        this.btn = this.querySelector('[data-nsp-btn]');
        this.priceEl = this.querySelector('[data-nsp-price]');
        this.metaEl = this.querySelector('[data-nsp-meta]');
        this.img = this.querySelector('.nsp__img');
        this.variants = JSON.parse(this.querySelector('[data-nsp-v]').textContent);
        this.opts = JSON.parse(this.querySelector('[data-nsp-o]').textContent);
        this.si = this.opts.findIndex((n) => /gr(ö|oe|o)(ß|ss)e|size/i.test(n));
        this.ci = this.opts.findIndex((n) => /farbe|colou?r/i.test(n));
        this.sizeChosen = this.si < 0 || /[?&]variant=/.test(location.search);
        const ov = this.nextElementSibling, sheet = ov?.nextElementSibling;
        if (ov?.matches('[data-nsp-ov]') && sheet?.matches('[data-nsp-sheet]')) {
          document.querySelectorAll('body > [data-nsp-ov], body > [data-nsp-sheet]').forEach((n) => n.remove());
          document.body.append(ov, sheet);
          this.ov = ov; this.sheet = sheet;
        } else {
          this.ov = document.querySelector('[data-nsp-ov]'); this.sheet = document.querySelector('[data-nsp-sheet]');
        }
        this.passed = false;

        this.onPick = (e) => {
          if (this.syncing) return;
          const picker = document.getElementById('variant-selects-' + this.sid);
          if (!picker || !picker.contains(e.target)) return;
          if (this.si >= 0 && e.target.name && (e.target.name.startsWith(this.opts[this.si]) || e.target.name.includes('[' + this.opts[this.si] + ']'))) this.sizeChosen = true;
          this.later();
        };
        document.addEventListener('change', this.onPick);
        this.btn.addEventListener('click', () => {
          if (this.si < 0 && this.ci < 0) return this.buy();
          if (this.sizeChosen) return this.buy();
          this.openSheet();
        });
        this.ov?.addEventListener('click', () => this.closeSheet());
        const s = this.sheet;
        s?.querySelector('[data-nsp-close]')?.addEventListener('click', () => this.closeSheet());
        s?.querySelector('[data-nsp-colors]')?.addEventListener('click', (e) => {
          const b = e.target.closest('button[data-color]');
          if (!b) return;
          this.selColor = b.dataset.color;
          const still = this.findV(this.selColor, this.selSize);
          if (!still || !still.available) this.selSize = null;
          this.renderSheet();
        });
        s?.querySelector('[data-nsp-sizes]')?.addEventListener('click', (e) => {
          const b = e.target.closest('button[data-size]');
          if (!b || b.disabled) return;
          this.selSize = b.dataset.size;
          s.querySelector('[data-nsp-sizes]').classList.remove('is-nudge');
          s.querySelector('[data-nsp-msg]').textContent = '';
          this.renderSheet();
        });
        s?.querySelector('[data-nsp-cta]')?.addEventListener('click', () => this.confirm());
        document.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.closeSheet(); });

        this.mo = new MutationObserver(() => this.later());
        const info = document.getElementById('ProductInfo-' + this.sid);
        if (info) this.mo.observe(info, { subtree: true, childList: true, attributes: true, attributeFilter: ['value', 'disabled', 'aria-disabled'] });
        this.onScroll = () => this.later();
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });
        this.update();
      }
      main() { return document.getElementById('ProductSubmitButton-' + this.sid); }
      form() { return document.getElementById('product-form-' + this.sid); }
      formId() { return Number(this.form()?.querySelector('[name="id"]')?.value || 0); }
      current() {
        const id = this.formId();
        return this.variants.find((v) => v.id === id) || this.variants.find((v) => v.available) || this.variants[0];
      }
      findV(color, size) {
        const base = this.current();
        return this.variants.find((x) => x.options.every((o, i) => {
          if (i === this.ci && color != null) return o === color;
          if (i === this.si) return size != null ? o === size : true;
          return o === base.options[i];
        }));
      }
      imgFor(color) {
        const v = this.variants.find((x) => (this.ci < 0 || x.options[this.ci] === color) && x.featured_image) || null;
        return v ? v.featured_image.src : null;
      }
      sized(src, w) { return src + (src.includes('?') ? '&' : '?') + 'width=' + w; }
      money(c) { return (c / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' }); }
      later() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
      }
      update() {
        const main = this.main();
        if (!main) return;
        const v = this.current();
        const box = document.getElementById('price-' + this.sid);
        const sale = box?.querySelector('.price-item--sale');
        const reg = box?.querySelector('.price__regular .price-item--regular');
        const shown = (box?.querySelector('.price--on-sale') ? sale : reg) || null;
        this.priceEl.textContent = shown ? shown.textContent.trim() : this.money(v.price);
        const color = this.ci >= 0 ? v.options[this.ci] : '';
        const size = this.si >= 0 ? v.options[this.si] : '';
        this.metaEl.textContent = [color, this.si >= 0 && this.sizeChosen ? 'Größe ' + size : ''].filter(Boolean).join(' · ');
        const src = v.featured_image?.src;
        if (src && this.lastImg !== src) { this.lastImg = src; this.img.src = this.sized(src, 120); }
        const soldOut = this.sizeChosen && (!v.available || main.disabled);
        this.btn.disabled = soldOut;
        this.btn.textContent = soldOut ? 'Ausverkauft' : (this.sizeChosen || (this.si < 0 && this.ci < 0) ? 'In den Warenkorb' : 'Auswählen');
        const passed = main.getBoundingClientRect().bottom < 0;
        if (passed !== this.passed) {
          this.passed = passed;
          this.classList.toggle('is-visible', passed);
          this.setAttribute('aria-hidden', String(!passed));
          this.btn.tabIndex = passed ? 0 : -1;
          if (!passed) this.closeSheet();
        }
      }
      openSheet() {
        if (!this.sheet) return;
        const v = this.current();
        this.selColor = this.ci >= 0 ? v.options[this.ci] : null;
        this.selSize = this.si >= 0 && this.sizeChosen ? v.options[this.si] : null;
        this.sheet.querySelector('[data-nsp-msg]').textContent = '';
        this.sheet.querySelector('[data-nsp-sizes]')?.classList.remove('is-nudge');
        this.renderSheet();
        this.ov.hidden = false; this.sheet.hidden = false;
        requestAnimationFrame(() => { this.ov.classList.add('is-open'); this.sheet.classList.add('is-open'); });
        this.sheetOpen = true;
      }
      renderSheet() {
        const s = this.sheet;
        if (!s) return;
        if (this.ci >= 0) {
          s.querySelectorAll('[data-nsp-colors] button').forEach((b) => {
            const has = this.variants.some((x) => x.options[this.ci] === b.dataset.color && x.available);
            b.hidden = !has;
            b.classList.toggle('is-on', b.dataset.color === this.selColor);
            b.setAttribute('aria-pressed', String(b.dataset.color === this.selColor));
          });
          const cn = s.querySelector('[data-nsp-cname]');
          if (cn) cn.textContent = this.selColor || '';
          const src = this.imgFor(this.selColor);
          if (src) s.querySelector('[data-nsp-simg]').src = this.sized(src, 240);
        }
        if (this.si >= 0) {
          const pool = this.variants.filter((x) => this.ci < 0 || x.options[this.ci] === this.selColor);
          const sizes = [...new Set(this.variants.map((x) => x.options[this.si]))];
          const wrap = s.querySelector('[data-nsp-sizes]');
          wrap.innerHTML = '';
          sizes.forEach((sz) => {
            const m = pool.find((x) => x.options[this.si] === sz);
            const b = document.createElement('button');
            b.type = 'button';
            b.dataset.size = sz;
            b.textContent = sz;
            if (!m || !m.available) { b.disabled = true; b.setAttribute('aria-label', sz + ' – ausverkauft'); }
            if (sz === this.selSize) b.classList.add('is-on');
            wrap.appendChild(b);
          });
          s.querySelector('[data-nsp-sname]').textContent = this.selSize || 'bitte wählen';
        }
        const want = this.findV(this.selColor, this.selSize);
        if (want) s.querySelector('[data-nsp-sprice]').textContent = this.money(want.price);
        const ready = this.si < 0 || !!this.selSize;
        const cta = s.querySelector('[data-nsp-cta]');
        cta.classList.toggle('is-off', !ready);
        s.querySelector('[data-nsp-ctat]').textContent = ready && want ? 'In den Warenkorb · ' + this.money(want.price) : 'Bitte Größe wählen';
      }
      closeSheet() {
        if (!this.sheetOpen) return;
        this.sheetOpen = false;
        this.ov.classList.remove('is-open'); this.sheet.classList.remove('is-open');
        setTimeout(() => { if (!this.sheetOpen) { this.ov.hidden = true; this.sheet.hidden = true; } }, 260);
      }
      setOption(idx, val) {
        const picker = document.getElementById('variant-selects-' + this.sid);
        if (!picker) return false;
        const name = this.opts[idx];
        const radio = [...picker.querySelectorAll('input[type="radio"]')].find((i) => i.name.startsWith(name) && i.value === val);
        if (radio) {
          if (radio.checked) return true;
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
          return true;
        }
        const sel = [...picker.querySelectorAll('select')].find((x) => x.name.includes('[' + name + ']'));
        if (sel) {
          if (sel.value === val) return true;
          sel.value = val;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
          return true;
        }
        return false;
      }
      async confirm() {
        const s = this.sheet;
        if (this.si >= 0 && !this.selSize) {
          s.querySelector('[data-nsp-msg]').textContent = 'Bitte wähle zuerst deine Größe.';
          s.querySelector('[data-nsp-sizes]').classList.add('is-nudge');
          return;
        }
        const want = this.findV(this.selColor, this.selSize);
        if (!want || !want.available) { s.querySelector('[data-nsp-msg]').textContent = 'Diese Auswahl ist leider ausverkauft.'; return; }
        const cta = s.querySelector('[data-nsp-cta]');
        cta.classList.add('is-busy');
        const y = window.scrollY;
        this.syncing = true;
        let ok = this.formId() === want.id;
        if (!ok) {
          if (this.ci >= 0 && this.current().options[this.ci] !== this.selColor) {
            this.setOption(this.ci, this.selColor);
            await this.waitFor(() => this.current().options[this.ci] === this.selColor && this.picker()?.querySelector('input,select'), 3000);
            await this.pause(120);
          }
          if (this.si >= 0 && this.formId() !== want.id) this.setOption(this.si, this.selSize);
          ok = await this.waitFor(() => this.formId() === want.id && !this.main()?.disabled, 3000);
        }
        this.syncing = false;
        this.sizeChosen = true;
        window.scrollTo({ top: y, behavior: 'instant' });
        this.closeSheet();
        cta.classList.remove('is-busy');
        if (ok) this.buy(); else await this.directAdd(want.id);
        this.later();
      }
      picker() { return document.getElementById('variant-selects-' + this.sid); }
      pause(ms) { return new Promise((r) => setTimeout(r, ms)); }
      buy() {
        const main = this.main();
        if (!main || main.disabled) return;
        const y = window.scrollY;
        this.btn.classList.add('is-busy');
        main.click();
        requestAnimationFrame(() => window.scrollTo({ top: y, behavior: 'instant' }));
        setTimeout(() => this.btn.classList.remove('is-busy'), 1200);
      }
      async directAdd(id) {
        try {
          const root = window.Shopify?.routes?.root || '/';
          const r = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id, quantity: 1 }] }) });
          if (!r.ok) throw new Error();
          const d = document.querySelector('cart-drawer.nd-cd');
          if (d && d.queue) d.queue(true); else location.href = root + 'cart';
        } catch (e) {
          this.openSheet();
          const m = this.sheet?.querySelector('[data-nsp-msg]');
          if (m) m.textContent = 'Das hat nicht geklappt. Bitte erneut versuchen.';
        }
      }
      waitFor(test, ms) {
        return new Promise((res) => {
          const t0 = Date.now();
          const tick = () => { if (test()) return res(true); if (Date.now() - t0 > ms) return res(false); setTimeout(tick, 80); };
          tick();
        });
      }
      disconnectedCallback() {
        this.mo?.disconnect();
        document.removeEventListener('change', this.onPick);
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        if (this.frame) cancelAnimationFrame(this.frame);
        this.ready = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
